import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ErrorType, ImagePathByErrorType } from './error.constants';

@Component({
  selector: 'mbs-error',
  templateUrl: 'error.component.html',
  host: { class: 'text-center d-flex justify-content-center align-items-center flex-column' }
})
export class ErrorComponent {
  readonly errorType = ErrorType;
  readonly imagePath = ImagePathByErrorType;
  @Input() type: ErrorType;
  @Input() hideNotFoundLink = false;

  constructor(private router: Router) {}

  refresh() {
    location.reload();
  }

  getI18NPath(part: string) {
    return `shared:error.type.${this.type}.${part}`;
  }

  goToDashboardRoute() {
    this.router.navigateByUrl('AP/DashboardRoute');
  }
}
